import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import React from "react";
import TechSupportHome from "./TechSupportHome";

const TechSupportHomePage = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 0,
      },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <TechSupportHome />
    </QueryClientProvider>
  );
};

export default TechSupportHomePage;
